export enum ESearchMethod {
  Popular = 'popular search',
  Text = 'insert',
  AutoComplete = 'autocomplete',
  Category = 'autocomplete category',
  Recent = 'recent search',
}

export interface ISearchRecent {
  createdAt: string;
  deletedAt: null;
  id: number;
  result: number;
  search: string;
  storeId: number;
  updatedAt: string;
  hasSponsor: boolean;
}
export interface ISearchPopular {
  image: string;
  id: number;
  initColor: string;
  search: string;
}

export enum ESearchFrom {
  Dashboard = 'dashboard',
  ProductShow = 'product show',
  SearchPage = 'search page',
}

export interface ISearchesResponse {
  recents: ISearchRecent[];
  popular: ISearchPopular[];
}
